import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhotoSizeSelectSmallIcon(props: IconProps) {
    return <Icon {...props} iconKey={"photo_size_select_small"}/>
}
